/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {

   
    
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
   


      
      
      // quick view on bundle set image slider change
     

      // button enable -- disable
      if(variant.available){
     
        $('.bundle_quick_form button.btn.btn-next.my_step_btn.quickSelct').attr('disabled', false); 
      }else{
        $('.bundle_quick_form button.btn.btn-next.my_step_btn.quickSelct').attr('disabled', true); 
      }
      // button enable -- disable

      $('.quickSelct').on('click',function(e){
      
        e.preventDefault();

        $('li.product-bundle-item.item_wrp.active').addClass('nextClicked');
        var Clinked = true;
        var selectedVariantId = variant.id;
        var variantPrice = variant.price;
        var variantComparePrice = variant.compare_at_price;
         if(variant.featured_media){
          var variantImage = variant.featured_media.preview_image.src;
        }
        var prcConvert = (parseFloat(variantPrice)/100).toFixed(2);
        var comparePrcConvert = (parseFloat(variantComparePrice)/100).toFixed(2);
        var mainProductId = parseInt($('li.product-bundle-item.item_wrp.active .product-bundle-item__image').attr('data-mainpdpid'));
        var quickViewId = parseInt($(this).attr('data-main-pdp'));
          // console.log(prcConvert+ "convert");
        // console.log(mainProductId);
         $('.ck_sel_variant option').each(function(){
                            
             var val = $(this).val();
             var idget = $(this).closest('.ck_sel_variant').attr('id');
             var splitted = idget.split('-');
             var mySelectId = parseInt(splitted[1]);
            
             var eachOption =variant.options;
             var selectedOption = eachOption.join(", ");

              // console.log(selectedOption);
                 console.log(mySelectId);
                if (quickViewId === mainProductId && mainProductId === mySelectId) {
                  if(selectedVariantId == val){
                   
                      $(this).prop("selected", "selected");
                      $('li.product-bundle-item.item_wrp.active .sel_variant_txt').html(selectedOption);
                   
                     if(variantImage){
                        $('li.product-bundle-item.item_wrp.active .setp_bg img').attr('src' , variantImage);
                      }
                      $("li.product-bundle-item.item_wrp.active .wrp_title_pop span.price_hidden").attr("data-id", prcConvert);
                      $("li.product-bundle-item.item_wrp.active .wrp_title_pop span.price_hidden").attr("data-cprc", comparePrcConvert);
                      
    
                         var total = 0;
                        var originaltotal = 0;
                           $('.item_wrp').each(function(idx){
                              var totalPc =parseFloat($(this).find('.product-bundle-item__content span').attr('data-id'));
                               // total+= totalPc;
                               // console.log(totalPc);
                              var totalCc =parseFloat($(this).find('.product-bundle-item__content span').attr('data-cprc'));
                              total+= totalCc;
                              originaltotal+= totalPc;
                         });
    
                          $('.total_all_pdp span').text('£'+total.toFixed(2));
                          $('.tot_item_price').text('£'+total.toFixed(2));

                    if(total > originaltotal){
                        console.log("here changed", originaltotal);
                         document.querySelector(".bundle_saving_prc").innerHTML = '£'+originaltotal.toFixed(2);
                         document.querySelector(".bundle_saving_prc_crt").innerHTML = '£'+originaltotal.toFixed(2);
                      }
                    
                          // var numVal1 = total;
                          // var numVal2 = parseInt(document.getElementById("discount_bundle").innerText) / 100;
                          // var totalValue = numVal1 - (numVal1 * numVal2);
                          // //console.log(totalValue);
                          // document.querySelector(".bundle_saving_prc").innerHTML = '£'+totalValue.toFixed(2);
                          // document.querySelector(".bundle_saving_prc_crt").innerHTML = '£'+totalValue.toFixed(2);
                    
                    // console.log($('#'+quickViewId));
                      
                    $('#'+quickViewId).find(' button.drawer__button.drawer__close').trigger('click');
                    
                       
                      return false;
                  }
                 }
             });
            
          });
      



       var imgTxtBind = $('.pro_wrap .cart_drawer_pro:checked').data('imgbind');
       setTimeout(function(){
          // $('.slider-thumb').slick('slickUnfilter');
          $('.slider-thumb').slick('slickFilter', `.${imgTxtBind}`);
       
          // $('.calendar-select').slick('slickUnfilter');
          $('.calendar-select').slick('slickFilter', `.${imgTxtBind}`);

      
          $('.slider-thumb .product__media').each(function(e){
              $(this).on('click',function(e){
                  e.preventDefault();
                  slideIndex = $(this).index();
                  console.log(slideIndex);
                  $('.calendar-select').slick('slickGoTo', parseInt(slideIndex));
              });
          });
         $('.calendar-select').slick('slickGoTo', 0);
       },100);
      
         
          

      
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();

document.addEventListener('theme:cart:change', (e) => {
 freeShippingMsg();
});
$('document').ready(function(){
  freeShippingMsg();
});
function freeShippingMsg(){
  
  fetch('/cart.js')
    .then((resp) => resp.json())
    .then((cart) => {
    if(cart.total_price > 0){
      
      var priceCart = cart.total_price;

      $('.shipping_box_wrp').removeClass('hidden');
      $('progress').attr('value',priceCart);
      // console.log(priceCart);
      
    }else{
      $('.shipping_box_wrp').addClass('hidden');
    }
      
  });
}
// CJ countdown timer
document.addEventListener("DOMContentLoaded", () => {
  if (!customElements.get('countdown-timer')) {
    customElements.define('countdown-timer', CountdownTimer);
  }
});
 

const selectors$177 = {
  time: 'time',
  days: '[data-days]',
  hours: '[data-hours]',
  minutes: '[data-minutes]',
  seconds: '[data-seconds]',
  shopifySection: '.shopify-section',
};

const attributes$2 = {
  expirationBehavior: 'data-expiration-behavior',
};

const classes$I = {
  showMessage: 'show-message',
  hideCountdown: 'hidden',
};

const settings = {
  hideSection: 'hide-section',
  showMessage: 'show-message',
};

class CountdownTimer extends HTMLElement {
  constructor() {
    super();

    this.shopifySection = this.closest(selectors$177.shopifySection);
    this.expirationBehavior = this.getAttribute(attributes$2.expirationBehavior);

    this.time = this.querySelector(selectors$177.time);
    this.days = this.querySelector(selectors$177.days);
    this.hours = this.querySelector(selectors$177.hours);
    this.minutes = this.querySelector(selectors$177.minutes);
    this.seconds = this.querySelector(selectors$177.seconds);

    // Get the current and expiration dates in Unix timestamp format (milliseconds)
    this.endDate = Date.parse(this.time.dateTime);
    this.daysInMs = 1000 * 60 * 60 * 24;
    this.hoursInMs = this.daysInMs / 24;
    this.minutesInMs = this.hoursInMs / 60;
    this.secondsInMs = this.minutesInMs / 60;

    this.shouldHideOnComplete = this.expirationBehavior === settings.hideSection;
    this.shouldShowMessage = this.expirationBehavior === settings.showMessage;

    this.update = this.update.bind(this);
  }

  connectedCallback() {
    if (isNaN(this.endDate)) {
      this.onComplete();
      return;
    }

    if (this.endDate <= Date.now()) {
      this.onComplete();
      return;
    }

    // Update the countdown every second
    this.interval = setInterval(this.update, 1000);
  }

  disconnectedCallback() {
    this.stopTimer();
  }

  convertTime(timeInMs) {
    const days = this.formatDigits(parseInt(timeInMs / this.daysInMs, 10));
    timeInMs -= days * this.daysInMs;

    const hours = this.formatDigits(parseInt(timeInMs / this.hoursInMs, 10));
    timeInMs -= hours * this.hoursInMs;

    const minutes = this.formatDigits(parseInt(timeInMs / this.minutesInMs, 10));
    timeInMs -= minutes * this.minutesInMs;

    const seconds = this.formatDigits(parseInt(timeInMs / this.secondsInMs, 10));

    return {
      days: days,
      hours: hours,
      minutes: minutes,
      seconds: seconds,
    };
  }

  // Make numbers less than 10 to appear with a leading zero like 01, 02, 03
  formatDigits(number) {
    if (number < 10) number = '0' + number;
    return number;
  }

  render(timer) {
    this.days.textContent = timer.days;
    this.hours.textContent = timer.hours;
    this.minutes.textContent = timer.minutes;
    this.seconds.textContent = timer.seconds;
  }

  stopTimer() {
    clearInterval(this.interval);
  }

  onComplete() {
    this.render({
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
    });

    if (this.shouldHideOnComplete) {
      this.shopifySection.classList.add(classes$I.hideCountdown);
    }

    if (this.shouldShowMessage) {
      this.classList.add(classes$I.showMessage);
    }
  }

  // Function to update the countdown
  update() {
    const timeNow = new Date().getTime();
    const timeDiff = this.endDate - timeNow;

    if (timeDiff <= 0) {
      this.stopTimer();
      this.onComplete();
    }

    const timeRemaining = this.convertTime(timeDiff);
    this.render(timeRemaining);
  }
}
// CJ countdown timer